import InlineSVG from "react-inlinesvg";
import { useProjectStore } from "src/stores/projectStore";
// @ts-ignore
import styled from "styled-components/macro";

function WorldbuildingGenerationAnimation() {
  const columnWidths = useProjectStore((state) => state.columnWidths);

  return (
    <AnimationContainer $columnWidths={columnWidths.center.current}>
      <InlineSVG
        className="ufo"
        src="/assets/ufo.svg"
        width={"50px"}
      />
      <InlineSVG
        className="wb-elements one"
        src="/assets/wb-elements-separated.svg"
        height={"200px"}
      />
      <InlineSVG
        className="wb-elements two"
        src="/assets/wb-elements-separated.svg"
        height={"200px"}
      />
      <InlineSVG
        className="wb-elements three"
        src="/assets/wb-elements-separated.svg"
        height={"200px"}
      />
      <InlineSVG
        className="mountain"
        src="/assets/mountain.svg"
        width={"100%"}
        preserveAspectRatio="none"
      />
    </AnimationContainer>
  );
}

const AnimationContainer = styled.div`
  --ufo-worldbuilding-color: var(--primary-cta-hover);
  @keyframes slide {
    100% {
      transform: translateX(-1500px);
    }
  }

  @keyframes dipInOut {
    0% {
      transform: translate(-100px, -100px);
    }
    40% {
      transform: translate(0);
    }
    60% {
      transform: translate(30px, 0);
    }
    70% {
      transform: translate(60px, 0);
    }
    100% {
      transform: translate(300px, -100px);
    }
  }

  @keyframes invisible {
    0% {
      opacity: 1;
    }
    25% {
      opacity: 1;
    }
    25.01% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
  width: 100%;
  height: 200px;
  display: flex;
  align-items: flex-end;
  position: relative;
  overflow: hidden;

  .mountain {
    ellipse, rect {
      fill: var(--menu-color-primary-cta-overlay-active);
    }
    .right-mountain {
      // make sure the mountain always covers the loading button text
      ${(props: { $columnWidths: number }) => {
        if (props.$columnWidths < 700) {
          return `
          rx: 200px;
          cx: 650;
          `;
        } else if (props.$columnWidths > 1000) {
          return `
          cx: 750;
          `;
        }
        return `rx: 200px; cx: 740;`;
      }}
    }
  }

  .ufo {
    position: absolute;
    top: 10px;
    left: 220px;
    animation:
      dipInOut 5s linear infinite forwards,
      invisible 20s linear infinite forwards;
    z-index: 1;

    path {
      fill: var(--ufo-worldbuilding-color);
    }
  }

  .wb-elements {
    z-index: -1;
    position: absolute;
    bottom: 10px;

    path {
      fill: var(--ufo-worldbuilding-color);
    }

    path.turbines {
      animation: rotate 10s linear infinite;
      transform-origin: 46.93% 59.82%;
    }
  }

  .wb-elements.one {
    animation: slide 30s linear forwards;
  }

  .wb-elements.two {
    transform: translateX(1500px);
    animation-delay: 30s;
    animation: slide 60s linear infinite;
  }

  .wb-elements.three {
    transform: translateX(1500px);
    animation: slide 60s linear infinite;
    animation-delay: 30s;
  }
`;

export default WorldbuildingGenerationAnimation;
